export default "__VITE_ASSET__CxODaeCz__"